export default __webpack_public_path__ + "static/media/people_shuffle.8c6beb36.gif";